export function assert(
  condition: unknown,
  message?: string | (() => string),
): asserts condition {
  if (condition) {
    return;
  }

  throw new Error(
    message
      ? `assertion failed ${
          typeof message === "function" ? message() : message
        }`
      : "assertion failed",
  );
}
